import { Droplets, Wrench, Leaf, FileText, ClipboardList } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function WhyChooseUs() {
  const benefits = [{
    id: 1,
    title: "Flächenreinigung ohne Chemie",
    description: "Umweltfreundliche Reinigung von Terrassen, Einfahrten und Flächen nur mit Wasser und Hochdrucktechnik.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/eco_friendly_surface_cleaning.png",
    icon: Droplets
  }, {
    id: 2,
    title: "Hausmeistertätigkeiten",
    description: "Professionelle Betreuung im nicht handwerkspflichtigen Bereich für Privat- und Geschäftskunden.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/professional_property_services.png",
    icon: Wrench
  }, {
    id: 3,
    title: "Gartenpflege",
    description: "Umfassende Gartenarbeiten von Heckenschnitt bis Laubbeseitigung für gepflegte Grünanlagen.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/comprehensive_garden_care.png",
    icon: Leaf
  }, {
    id: 4,
    title: "Bürotätigkeiten",
    description: "Effiziente administrative Unterstützung und professionelle Büroorganisation für Ihr Unternehmen.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/efficient_office_work.png",
    icon: FileText
  }, {
    id: 5,
    title: "Büroorganisation",
    description: "Hilfeleistungen bei der Strukturierung und Optimierung Ihrer organisatorischen Abläufe.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_organization_support.png",
    icon: ClipboardList
  }];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold text-foreground">
            Warum Münsterland Industrieservice?
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Fünf Leistungsbereiche – alle gleichwertig und professionell ausgeführt.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {benefits.map((benefit, i) => {
          const IconComponent = benefit.icon;
          return <div key={benefit.id} data-index={i} className="animate-fade-in-up">
                <Card className="h-full border border-border shadow-soft transition-all duration-[var(--duration-medium)] hover:-translate-y-1 hover:shadow-medium">
                  <img src={benefit.image} alt={benefit.title} className="h-48 w-full rounded-t-lg object-cover" />
                  <CardHeader>
                    <div className="mb-2 flex items-center gap-3">
                      <div className="flex size-10 items-center justify-center rounded-lg bg-primary/10">
                        <IconComponent className="size-5 text-primary" />
                      </div>
                      <CardTitle className="text-xl">{benefit.title}</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </CardContent>
                  <CardFooter>
                    <Button asChild className="w-full bg-primary text-primary-foreground hover:bg-primary-hover">
                      <Link to="/KontaktPage">Mehr erfahren</Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}